import { Routes, Route, Navigate } from "react-router-dom";
import Login from "@/features/auth/components/Login/Login";
import LoginRedirect from "@/features/auth/components/LoginRedirect/LoginRedirect";
import RequireAuth from "@/components/RequireAuth/RequireAuth";
import MainLayout from "@/components/MainLayout/MainLayout";
import Home from "@/features/home/components/Home/Home";
import AppAuthenticated from "@/features/auth/components/AppAuthenticated/AppAuthenticated";
import Logout from "@/features/auth/components/Logout/Logout";
import MagicLinkSent from "@/features/auth/components/MagicLinkSent/MagicLinkSent";
import EmailNotificationsList from "@/features/adminEmailNotifications/components/EmailNotificationsList/EmailNotificationsList";
import MyChapterDashboard from "@/features/myChapter/components/MyChapterDashboard/MyChapterDashboard";
import ForbiddenPage from "@/features/auth/components/ForbiddenPage/ForbiddenPage";
import AdminGuard from "@/components/AdminGuard/AdminGuard";
import ChapterActivitiesList from "@/features/myChapterActivity/components/ChapterActivitiesList/ChapterActivitiesList";
import MyEmailNotificationsList from "@/features/myEmailNotifications/components/MyEmailNotificationsList/MyEmailNotificationsList";
import SubmitChapterActivityForm from "@/features/myChapterActivity/components/SubmitChapterActivityForm/SubmitChapterActivityForm";
import CreateNotificationForm from "@/features/myEmailNotifications/components/CreateNotificationForm/CreateNotificationForm";

function AppRoutes() {
  return (
    <Routes>
      <Route element={<Login />} path="/login" />
      <Route element={<Logout />} path="/logout" />
      <Route element={<LoginRedirect />} path="/login-redirect" />
      <Route element={<MagicLinkSent />} path="/login/magic-link-sent" />
      <Route element={<ForbiddenPage />} path="/403" />

      <Route
        element={
          <RequireAuth>
            <AppAuthenticated>
              <MainLayout />
            </AppAuthenticated>
          </RequireAuth>
        }
        path="/"
      >
        <Route element={<Home />} index />
        <Route
          element={
            <AdminGuard>
              <EmailNotificationsList />
            </AdminGuard>
          }
          path="admin/email-notifications"
        />
        <Route element={<MyChapterDashboard />} path="my-chapter" />
        <Route element={<ChapterActivitiesList />} path="chapter-activities" />
        <Route element={<SubmitChapterActivityForm />} path="submit-activity" />
        <Route
          element={<CreateNotificationForm />}
          path="create-notification"
        />
        <Route
          element={<MyEmailNotificationsList />}
          path="my-email-notifications"
        />
      </Route>

      <Route element={<Navigate replace to="/" />} path="*" />
    </Routes>
  );
}

export default AppRoutes;
